<template>
  <div class="content">
    <div v-if="info" class="detail">
      <div v-if="textContent" class="text-content">
        {{ info.textContent }}
      </div>
      <!--     媒体 -->
      <div v-if="imageUrls.length > 0 || videoUrls.length > 0" class="media-list">
        <div v-for="item in imageUrls" class="media-item" :key="item">
          <el-image fit="contain" :preview-src-list="imageUrls" :src="item" style="height: 100%" />
        </div>
        <div v-for="item in videoUrls" class="media-item" :key="item">
          <video controls="controls" :src="item" style="height: 100%" />
        </div>
      </div>
      <div v-if="fileList.length > 0" class="file-list">
        <div v-for="item in fileList" class="file-item" :key="item">
          <div class="file-name">
            <i class="el-icon-document" />
            <span>{{ item.name }}</span>
          </div>
          <div class="option">
            <el-link type="info" @click="viewFile(item.content, item.name)">
              <i class="el-icon-view"></i>
              预览
            </el-link>
            <el-link style="margin-left: 10px" type="primary" @click="viewFile(item.content, item.name)">
              <i class="el-icon-download"></i>
              下载
            </el-link>
          </div>
        </div>
      </div>
      <div v-if="mdContent" class="md-content">
        <div ref="content" v-html="renderedMarkdown()" />
      </div>
    </div>
  </div>
</template>

<script>
import { getClockInLog } from '@/api/demo/record'
import axios from 'axios'
import { parse } from 'marked'

export default {
  name: 'ProjectListItem',
  components: {},
  props: {
    id: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      info: null,
      fileList: [],
      videoUrls: [],
      imageUrls: [],
      textContent: '',
      mdContent: ''
    }
  },
  watch: {
    id: {
      handler: function (val, oldVal) {
        this.getInfo()
      },
      deep: true
    }
  },
  created () {
    this.getInfo()
  },
  mounted () { },
  methods: {
    async exportToPDF () {
      const content = this.$refs.content
      const pdf = new jsPDF()
      pdf.html(content, {
        callback: function (pdf) {
          pdf.save('content.pdf')
        },
        x: 10,
        y: 10
      })
    },
    renderedMarkdown () {
      // 使用 marked 将 Markdown 转换为 HTML
      const renderer = new parse.Renderer()
      renderer.image = function (href, title, text) {
        return `<img src="${href}" alt="${text}" title="${title || ''}" style="max-width: 100%; height: auto; display: block;" />`
      }
      return parse(this.mdContent, { renderer })
    },
    viewFile (url, name) {
      console.log(url)
      axios.create().get(url, {
        responseType: 'blob'
      }).then((res) => {
        console.log('res====', res)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) // 或者其他文件名
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        link.remove()
      })
    },
    getInfo () {
      this.info = null
      this.fileList = []
      this.videoUrls = []
      this.imageUrls = []
      this.mdContent = ''
      getClockInLog(this.id).then((res) => {
        console.log('res', res)
        this.info = res
        if (this.info.fileContent) this.fileList = JSON.parse(this.info.fileContent)
        if (this.info.videoContent) this.videoUrls = this.info.videoContent.split(',')
        if (this.info.imgContent) this.imageUrls = this.info.imgContent.split(',')
        if (this.info.mdContent) this.mdContent = this.info.mdContent
        console.log('this.mdContent', this.mdContent)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.media-list {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .media-item {
    width: 200px;
    height: 300px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  }
}

.file-list {
  margin-top: 20px;

  .file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #eee;

    .file-name {
      display: flex;
      align-items: center;

      i {
        font-size: 20px;
        margin-right: 10px;
      }

      span {
        font-size: 14px;
      }
    }

    .file-size {
      font-size: 14px;
    }

    .option {}
  }
}

.title {
  text-align: left;
  border-bottom: 1px solid #eee;

  h1 {
    font-size: 20px;
    font-weight: 600;
  }
}

.detail {
  padding: 40px;

  .text-content {
    text-align: left;
    letter-spacing: 0.5px;
    line-height: 1.8;
    margin-top: 14px;
    font-size: 14px;
  }
}

.author {
  text-align: left;
  padding-left: 20px;
}

.content {
  width: 100%;
  min-height: 500px;

}

.menu {
  z-index: 999;
  background-color: #fff;
  padding: 14px;
  border-radius: 10px;
  position: fixed;
  right: 220px;
  bottom: 20px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

  i {
    font-size: 28px;
    cursor: pointer;
  }
}

.md-content img {
  max-width: 100%;
  /* 图片最大宽度不超过容器 */
  height: auto;
  /* 保持宽高比 */
  display: block;
  /* 防止 inline 问题 */
  margin: 0 auto;
  /* 可选：居中图片 */
}
</style>
